export const color = {
    "callout": {
        "text": {
            "info": "var(--colorCalloutTextInfo)",
            "success": "var(--colorCalloutTextSuccess)",
            "warning": "var(--colorCalloutTextWarning)",
            "danger": "var(--colorCalloutTextDanger)",
            "feature": "var(--colorCalloutTextFeature)",
            "default": "var(--colorCalloutTextDefault)",
            "body": "var(--colorCalloutTextBody)"
        },
        "icon": {
            "info": "var(--colorCalloutIconInfo)",
            "success": "var(--colorCalloutIconSuccess)",
            "warning": "var(--colorCalloutIconWarning)",
            "danger": "var(--colorCalloutIconDanger)",
            "feature": "var(--colorCalloutIconFeature)",
            "default": "var(--colorCalloutIconDefault)"
        },
        "border": {
            "info": "var(--colorCalloutBorderInfo)",
            "success": "var(--colorCalloutBorderSuccess)",
            "warning": "var(--colorCalloutBorderWarning)",
            "danger": "var(--colorCalloutBorderDanger)",
            "feature": "var(--colorCalloutBorderFeature)",
            "default": "var(--colorCalloutBorderDefault)"
        },
        "background": {
            "info": {
                "default": "var(--colorCalloutBackgroundInfoDefault)",
                "hover": "var(--colorCalloutBackgroundInfoHover)",
                "pressed": "var(--colorCalloutBackgroundInfoPressed)"
            },
            "success": {
                "default": "var(--colorCalloutBackgroundSuccessDefault)",
                "hover": "var(--colorCalloutBackgroundSuccessHover)",
                "pressed": "var(--colorCalloutBackgroundSuccessPressed)"
            },
            "attention": {
                "default": "var(--colorCalloutBackgroundAttentionDefault)",
                "hover": "var(--colorCalloutBackgroundAttentionHover)",
                "pressed": "var(--colorCalloutBackgroundAttentionPressed)"
            },
            "danger": {
                "default": "var(--colorCalloutBackgroundDangerDefault)",
                "hover": "var(--colorCalloutBackgroundDangerHover)",
                "pressed": "var(--colorCalloutBackgroundDangerPressed)"
            },
            "feature": {
                "default": "var(--colorCalloutBackgroundFeatureDefault)",
                "hover": "var(--colorCalloutBackgroundFeatureHover)",
                "pressed": "var(--colorCalloutBackgroundFeaturePressed)"
            },
            "default": {
                "default": "var(--colorCalloutBackgroundDefaultDefault)",
                "hover": "var(--colorCalloutBackgroundDefaultHover)",
                "pressed": "var(--colorCalloutBackgroundDefaultPressed)"
            }
        }
    },
    "menuList": {
        "text": {
            "primary": "var(--colorMenuListTextPrimary)",
            "secondary": "var(--colorMenuListTextSecondary)",
            "highlight": "var(--colorMenuListTextHighlight)"
        },
        "background": {
            "default": "var(--colorMenuListBackgroundDefault)",
            "hover": "var(--colorMenuListBackgroundHover)"
        },
        "icon": {
            "primary": "var(--colorMenuListIconPrimary)"
        }
    },
    "textField": {
        "text": {
            "primary": "var(--colorTextFieldTextPrimary)",
            "secondary": "var(--colorTextFieldTextSecondary)",
            "selected": "var(--colorTextFieldTextSelected)",
            "danger": "var(--colorTextFieldTextDanger)",
            "disabled": "var(--colorTextFieldTextDisabled)"
        },
        "border": {
            "default": "var(--colorTextFieldBorderDefault)",
            "hover": "var(--colorTextFieldBorderHover)",
            "active": "var(--colorTextFieldBorderActive)",
            "danger": "var(--colorTextFieldBorderDanger)",
            "disabled": "var(--colorTextFieldBorderDisabled)"
        },
        "icon": {
            "primary": "var(--colorTextFieldIconPrimary)",
            "disabled": "var(--colorTextFieldIconDisabled)"
        }
    },
    "chip": {
        "filled": {
            "text": {
                "primary": "var(--colorChipFilledTextPrimary)",
                "secondary": "var(--colorChipFilledTextSecondary)",
                "info": "var(--colorChipFilledTextInfo)",
                "success": "var(--colorChipFilledTextSuccess)",
                "warning": "var(--colorChipFilledTextWarning)",
                "danger": "var(--colorChipFilledTextDanger)"
            },
            "background": {
                "primary": "var(--colorChipFilledBackgroundPrimary)",
                "secondary": "var(--colorChipFilledBackgroundSecondary)",
                "info": "var(--colorChipFilledBackgroundInfo)",
                "success": "var(--colorChipFilledBackgroundSuccess)",
                "warning": "var(--colorChipFilledBackgroundWarning)",
                "danger": "var(--colorChipFilledBackgroundDanger)"
            },
            "icon": {
                "primary": "var(--colorChipFilledIconPrimary)",
                "secondary": "var(--colorChipFilledIconSecondary)",
                "info": "var(--colorChipFilledIconInfo)",
                "success": "var(--colorChipFilledIconSuccess)",
                "warning": "var(--colorChipFilledIconWarning)",
                "danger": "var(--colorChipFilledIconDanger)"
            }
        },
        "outlined": {
            "border": {
                "primary": "var(--colorChipOutlinedBorderPrimary)",
                "secondary": "var(--colorChipOutlinedBorderSecondary)",
                "info": "var(--colorChipOutlinedBorderInfo)",
                "success": "var(--colorChipOutlinedBorderSuccess)",
                "warning": "var(--colorChipOutlinedBorderWarning)",
                "danger": "var(--colorChipOutlinedBorderDanger)"
            },
            "text": {
                "primary": "var(--colorChipOutlinedTextPrimary)",
                "secondary": "var(--colorChipOutlinedTextSecondary)",
                "info": "var(--colorChipOutlinedTextInfo)",
                "success": "var(--colorChipOutlinedTextSuccess)",
                "warning": "var(--colorChipOutlinedTextWarning)",
                "danger": "var(--colorChipOutlinedTextDanger)"
            },
            "icon": {
                "primary": "var(--colorChipOutlinedIconPrimary)",
                "secondary": "var(--colorChipOutlinedIconSecondary)",
                "info": "var(--colorChipOutlinedIconInfo)",
                "success": "var(--colorChipOutlinedIconSuccess)",
                "warning": "var(--colorChipOutlinedIconWarning)",
                "danger": "var(--colorChipOutlinedIconDanger)"
            }
        }
    },
    "button": {
        "background": {
            "primary": {
                "default": "var(--colorButtonBackgroundPrimaryDefault)",
                "hover": "var(--colorButtonBackgroundPrimaryHover)",
                "pressed": "var(--colorButtonBackgroundPrimaryPressed)"
            },
            "secondary": {
                "default": "var(--colorButtonBackgroundSecondaryDefault)",
                "hover": "var(--colorButtonBackgroundSecondaryHover)",
                "pressed": "var(--colorButtonBackgroundSecondaryPressed)"
            },
            "tertiary": {
                "default": "var(--colorButtonBackgroundTertiaryDefault)",
                "hover": "var(--colorButtonBackgroundTertiaryHover)",
                "pressed": "var(--colorButtonBackgroundTertiaryPressed)"
            },
            "destructive": {
                "default": "var(--colorButtonBackgroundDestructiveDefault)",
                "hover": "var(--colorButtonBackgroundDestructiveHover)",
                "pressed": "var(--colorButtonBackgroundDestructivePressed)"
            },
            "quiet": {
                "default": "var(--colorButtonBackgroundQuietDefault)",
                "hover": "var(--colorButtonBackgroundQuietHover)",
                "pressed": "var(--colorButtonBackgroundQuietPressed)"
            },
            "loud": {
                "default": "var(--colorButtonBackgroundLoudDefault)",
                "hover": "var(--colorButtonBackgroundLoudHover)",
                "pressed": "var(--colorButtonBackgroundLoudPressed)"
            },
            "neutral": {
                "default": "var(--colorButtonBackgroundNeutralDefault)",
                "hover": "var(--colorButtonBackgroundNeutralHover)",
                "pressed": "var(--colorButtonBackgroundNeutralPressed)"
            },
            "disabled": "var(--colorButtonBackgroundDisabled)"
        },
        "text": {
            "primary": "var(--colorButtonTextPrimary)",
            "secondary": "var(--colorButtonTextSecondary)",
            "tertiary": "var(--colorButtonTextTertiary)",
            "destructive": "var(--colorButtonTextDestructive)",
            "quiet": "var(--colorButtonTextQuiet)",
            "loud": "var(--colorButtonTextLoud)",
            "neutral": "var(--colorButtonTextNeutral)",
            "disabled": "var(--colorButtonTextDisabled)"
        },
        "border": {
            "secondary": "var(--colorButtonBorderSecondary)",
            "disabled": "var(--colorButtonBorderDisabled)"
        },
        "icon": {
            "primary": "var(--colorButtonIconPrimary)",
            "secondary": "var(--colorButtonIconSecondary)",
            "tertiary": "var(--colorButtonIconTertiary)",
            "destructive": "var(--colorButtonIconDestructive)",
            "quiet": "var(--colorButtonIconQuiet)",
            "loud": "var(--colorButtonIconLoud)",
            "neutral": "var(--colorButtonIconNeutral)",
            "disabled": "var(--colorButtonIconDisabled)"
        }
    },
    "dialog": {
        "background": {
            "primary": "var(--colorDialogBackgroundPrimary)"
        },
        "helpPanel": {
            "text": "var(--colorDialogHelpPanelText)"
        }
    },
    "progress": {
        "background": {
            "primary": "var(--colorProgressBackgroundPrimary)",
            "secondary": "var(--colorProgressBackgroundSecondary)"
        },
        "text": {
            "info": "var(--colorProgressTextInfo)"
        }
    },
    "progressBar": {
        "foreground": {
            "linear": "var(--colorProgressBarForegroundLinear)",
            "circular": "var(--colorProgressBarForegroundCircular)"
        },
        "background": {
            "linear": "var(--colorProgressBarBackgroundLinear)"
        },
        "text": {
            "primary": "var(--colorProgressBarTextPrimary)"
        }
    },
    "navigation": {
        "background": {
            "primary": "var(--colorNavigationBackgroundPrimary)",
            "secondary": "var(--colorNavigationBackgroundSecondary)"
        },
        "button": {
            "background": {
                "default": "var(--colorNavigationButtonBackgroundDefault)",
                "hover": "var(--colorNavigationButtonBackgroundHover)",
                "pressed": "var(--colorNavigationButtonBackgroundPressed)"
            },
            "text": {
                "default": "var(--colorNavigationButtonTextDefault)",
                "hover": "var(--colorNavigationButtonTextHover)",
                "pressed": "var(--colorNavigationButtonTextPressed)"
            },
            "icon": {
                "default": "var(--colorNavigationButtonIconDefault)",
                "hover": "var(--colorNavigationButtonIconHover)",
                "pressed": "var(--colorNavigationButtonIconPressed)"
            },
            "border": {
                "primary": "var(--colorNavigationButtonBorderPrimary)"
            }
        },
        "link": {
            "background": {
                "default": "var(--colorNavigationLinkBackgroundDefault)",
                "hover": "var(--colorNavigationLinkBackgroundHover)",
                "pressed": "var(--colorNavigationLinkBackgroundPressed)",
                "active": "var(--colorNavigationLinkBackgroundActive)",
                "passive": "var(--colorNavigationLinkBackgroundPassive)"
            },
            "text": {
                "default": "var(--colorNavigationLinkTextDefault)",
                "hover": "var(--colorNavigationLinkTextHover)",
                "pressed": "var(--colorNavigationLinkTextPressed)",
                "active": "var(--colorNavigationLinkTextActive)"
            },
            "icon": {
                "default": "var(--colorNavigationLinkIconDefault)",
                "hover": "var(--colorNavigationLinkIconHover)",
                "pressed": "var(--colorNavigationLinkIconPressed)",
                "active": "var(--colorNavigationLinkIconActive)"
            },
            "border": {
                "primary": "var(--colorNavigationLinkBorderPrimary)"
            }
        },
        "border": {
            "primary": "var(--colorNavigationBorderPrimary)"
        }
    },
    "pagination": {
        "background": {
            "default": "var(--colorPaginationBackgroundDefault)",
            "hover": "var(--colorPaginationBackgroundHover)",
            "active": "var(--colorPaginationBackgroundActive)",
            "disabled": "var(--colorPaginationBackgroundDisabled)"
        },
        "text": {
            "default": "var(--colorPaginationTextDefault)",
            "hover": "var(--colorPaginationTextHover)",
            "active": "var(--colorPaginationTextActive)",
            "disabled": "var(--colorPaginationTextDisabled)"
        },
        "icon": {
            "default": "var(--colorPaginationIconDefault)",
            "hover": "var(--colorPaginationIconHover)",
            "active": "var(--colorPaginationIconActive)",
            "disabled": "var(--colorPaginationIconDisabled)"
        }
    },
    "toggle": {
        "icon": {
            "default": "var(--colorToggleIconDefault)",
            "active": "var(--colorToggleIconActive)",
            "disabled": "var(--colorToggleIconDisabled)"
        },
        "background": {
            "on": "var(--colorToggleBackgroundOn)",
            "off": "var(--colorToggleBackgroundOff)",
            "disabled": "var(--colorToggleBackgroundDisabled)"
        },
        "foreground": {
            "on": "var(--colorToggleForegroundOn)",
            "off": "var(--colorToggleForegroundOff)",
            "disabled": "var(--colorToggleForegroundDisabled)"
        },
        "overlay": {
            "on": "var(--colorToggleOverlayOn)",
            "off": "var(--colorToggleOverlayOff)"
        }
    },
    "text": {
        "primary": "var(--colorTextPrimary)",
        "secondary": "var(--colorTextSecondary)",
        "tertiary": "var(--colorTextTertiary)",
        "disabled": "var(--colorTextDisabled)",
        "inverse": "var(--colorTextInverse)",
        "selected": "var(--colorTextSelected)",
        "info": "var(--colorTextInfo)",
        "success": "var(--colorTextSuccess)",
        "warning": "var(--colorTextWarning)",
        "danger": "var(--colorTextDanger)",
        "feature": "var(--colorTextFeature)",
        "link": {
            "default": "var(--colorTextLinkDefault)",
            "pressed": "var(--colorTextLinkPressed)"
        }
    },
    "icon": {
        "primary": "var(--colorIconPrimary)",
        "secondary": "var(--colorIconSecondary)",
        "tertiary": "var(--colorIconTertiary)",
        "disabled": "var(--colorIconDisabled)",
        "inverse": "var(--colorIconInverse)",
        "selected": "var(--colorIconSelected)",
        "info": "var(--colorIconInfo)",
        "success": "var(--colorIconSuccess)",
        "warning": "var(--colorIconWarning)",
        "attention": "var(--colorIconAttention)",
        "danger": "var(--colorIconDanger)",
        "feature": "var(--colorIconFeature)",
        "link": {
            "default": "var(--colorIconLinkDefault)",
            "pressed": "var(--colorIconLinkPressed)"
        }
    },
    "border": {
        "primary": "var(--colorBorderPrimary)",
        "secondary": "var(--colorBorderSecondary)",
        "tertiary": "var(--colorBorderTertiary)",
        "disabled": "var(--colorBorderDisabled)",
        "inverse": "var(--colorBorderInverse)",
        "selected": "var(--colorBorderSelected)",
        "info": "var(--colorBorderInfo)",
        "success": "var(--colorBorderSuccess)",
        "warning": "var(--colorBorderWarning)",
        "danger": "var(--colorBorderDanger)",
        "feature": "var(--colorBorderFeature)",
        "input": "var(--colorBorderInput)",
        "link": {
            "default": "var(--colorBorderLinkDefault)",
            "pressed": "var(--colorBorderLinkPressed)"
        }
    },
    "background": {
        "primary": {
            "default": "var(--colorBackgroundPrimaryDefault)",
            "hovered": "var(--colorBackgroundPrimaryHovered)",
            "pressed": "var(--colorBackgroundPrimaryPressed)",
            "transparent": "var(--colorBackgroundPrimaryTransparent)"
        },
        "secondary": {
            "default": "var(--colorBackgroundSecondaryDefault)",
            "hovered": "var(--colorBackgroundSecondaryHovered)",
            "pressed": "var(--colorBackgroundSecondaryPressed)"
        },
        "tertiary": "var(--colorBackgroundTertiary)",
        "disabled": "var(--colorBackgroundDisabled)",
        "contrast": "var(--colorBackgroundContrast)",
        "inverse": {
            "primary": "var(--colorBackgroundInversePrimary)",
            "secondary": "var(--colorBackgroundInverseSecondary)",
            "neutral": "var(--colorBackgroundInverseNeutral)",
            "success": "var(--colorBackgroundInverseSuccess)"
        },
        "selected": "var(--colorBackgroundSelected)",
        "info": "var(--colorBackgroundInfo)",
        "success": "var(--colorBackgroundSuccess)",
        "warning": "var(--colorBackgroundWarning)",
        "danger": "var(--colorBackgroundDanger)",
        "feature": "var(--colorBackgroundFeature)",
        "primary-exp": {
            "default": "var(--colorBackgroundPrimary-expDefault)",
            "hovered": "var(--colorBackgroundPrimary-expHovered)",
            "pressed": "var(--colorBackgroundPrimary-expPressed)"
        },
        "supplemantary": {
            "default": "var(--colorBackgroundSupplemantaryDefault)"
        }
    },
    "overlay": {
        "background": {
            "primary": "var(--colorOverlayBackgroundPrimary)",
            "muted": "var(--colorOverlayBackgroundMuted)"
        }
    },
    "actionButton": {
        "border": {
            "secondary": "var(--colorActionButtonBorderSecondary)",
            "disabled": "var(--colorActionButtonBorderDisabled)"
        },
        "text": {
            "primary": "var(--colorActionButtonTextPrimary)",
            "secondary": "var(--colorActionButtonTextSecondary)",
            "ternary": "var(--colorActionButtonTextTernary)",
            "disabled": "var(--colorActionButtonTextDisabled)"
        },
        "icon": {
            "primary": "var(--colorActionButtonIconPrimary)",
            "secondary": "var(--colorActionButtonIconSecondary)",
            "ternary": "var(--colorActionButtonIconTernary)",
            "disabled": "var(--colorActionButtonIconDisabled)"
        },
        "background": {
            "disabled": "var(--colorActionButtonBackgroundDisabled)",
            "primary": {
                "default": "var(--colorActionButtonBackgroundPrimaryDefault)",
                "hover": "var(--colorActionButtonBackgroundPrimaryHover)",
                "pressed": "var(--colorActionButtonBackgroundPrimaryPressed)"
            },
            "secondary": {
                "default": "var(--colorActionButtonBackgroundSecondaryDefault)",
                "hover": "var(--colorActionButtonBackgroundSecondaryHover)",
                "pressed": "var(--colorActionButtonBackgroundSecondaryPressed)"
            },
            "ternary": {
                "default": "var(--colorActionButtonBackgroundTernaryDefault)",
                "hover": "var(--colorActionButtonBackgroundTernaryHover)",
                "pressed": "var(--colorActionButtonBackgroundTernaryPressed)"
            },
            "createRelease": {
                "default": "var(--colorActionButtonBackgroundCreateReleaseDefault)",
                "hover": "var(--colorActionButtonBackgroundCreateReleaseHover)",
                "pressed": "var(--colorActionButtonBackgroundCreateReleasePressed)"
            }
        }
    },
    "card": {
        "background": {
            "default": "var(--colorCardBackgroundDefault)",
            "hover": "var(--colorCardBackgroundHover)"
        }
    },
    "carousel": {
        "text": {
            "primary": "var(--colorCarouselTextPrimary)",
            "muted": "var(--colorCarouselTextMuted)"
        },
        "icon": {
            "default": "var(--colorCarouselIconDefault)",
            "hover": "var(--colorCarouselIconHover)",
            "selected": "var(--colorCarouselIconSelected)",
            "active": "var(--colorCarouselIconActive)"
        },
        "background": {
            "primary": "var(--colorCarouselBackgroundPrimary)"
        }
    },
    "navList": {
        "text": {
            "default": "var(--colorNavListTextDefault)",
            "hover": "var(--colorNavListTextHover)",
            "active": "var(--colorNavListTextActive)"
        },
        "icon": {
            "default": "var(--colorNavListIconDefault)",
            "hover": "var(--colorNavListIconHover)",
            "active": "var(--colorNavListIconActive)"
        },
        "background": {
            "default": "var(--colorNavListBackgroundDefault)",
            "hover": "var(--colorNavListBackgroundHover)",
            "active": "var(--colorNavListBackgroundActive)"
        }
    },
    "popover": {
        "background": {
            "primary": "var(--colorPopoverBackgroundPrimary)",
            "secondary": "var(--colorPopoverBackgroundSecondary)"
        }
    },
    "codeEditor": {
        "background": "var(--colorCodeEditorBackground)",
        "text": {
            "default": "var(--colorCodeEditorTextDefault)",
            "highlight": "var(--colorCodeEditorTextHighlight)",
            "hintHighlight": "var(--colorCodeEditorTextHintHighlight)",
            "gutter": "var(--colorCodeEditorTextGutter)"
        },
        "code": {
            "selectedBackground": "var(--colorCodeEditorCodeSelectedBackground)",
            "linenumberColor": "var(--colorCodeEditorCodeLinenumberColor)",
            "cursorBorderLeft": "var(--colorCodeEditorCodeCursorBorderLeft)",
            "cursorBorderRight": "var(--colorCodeEditorCodeCursorBorderRight)",
            "activelineBackground": "var(--colorCodeEditorCodeActivelineBackground)",
            "fatCursorBackground": "var(--colorCodeEditorCodeFatCursorBackground)",
            "atomNumberKeywordVariableAttributeQuoteColor": "var(--colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor)",
            "variableColor": "var(--colorCodeEditorCodeVariableColor)",
            "propertyColor": "var(--colorCodeEditorCodePropertyColor)",
            "punctuationUnitNegativeColor": "var(--colorCodeEditorCodePunctuationUnitNegativeColor)",
            "stringOperatorColor": "var(--colorCodeEditorCodeStringOperatorColor)",
            "positiveColor": "var(--colorCodeEditorCodePositiveColor)",
            "variable2Variable3String2UrlColor": "var(--colorCodeEditorCodeVariable2Variable3String2UrlColor)",
            "defTagBuiltinQualifierHeaderEmColor": "var(--colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor)",
            "bracketCommentColor": "var(--colorCodeEditorCodeBracketCommentColor)",
            "errorInvalidcharColor": "var(--colorCodeEditorCodeErrorInvalidcharColor)",
            "matchingbracketColor": "var(--colorCodeEditorCodeMatchingbracketColor)",
            "hintsBackground": "var(--colorCodeEditorCodeHintsBackground)",
            "hint": "var(--colorCodeEditorCodeHint)",
            "hintActiveBackground": "var(--colorCodeEditorCodeHintActiveBackground)"
        },
        "toolbar": {
            "background": "var(--colorCodeEditorToolbarBackground)",
            "button": {
                "hover": "var(--colorCodeEditorToolbarButtonHover)"
            }
        }
    }
} as const;
export const shadow = {
    "extraSmall": "var(--shadowExtraSmall)",
    "small": "var(--shadowSmall)",
    "medium": "var(--shadowMedium)",
    "large": "var(--shadowLarge)",
    "layoutPrimary": "var(--shadowLayoutPrimary)",
    "focus": {
        "default": "var(--shadowFocusDefault)"
    }
} as const;
